import styled from "@emotion/styled";
import {  Grid, keyframes, } from "@mui/material";
const GridHEading = styled(Grid)`
/* padding: 50px 0; */
display: flex;
align-items: center;
justify-content: center;
text-align: center;
@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const GridImage = styled(Grid)`
/* padding: 50px 0 0;
    min-height: calc(75vh - 0px); */
text-align: center;

@media screen and (max-width:1199px){
  
  /* min-height: calc(81vh - 100px); */
}
@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "150PX")}; */
  margin-right: 20px;
  @media screen and (max-width:599px){
    margin-right: 20px;
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const BuyNow = styled.a`
text-decoration: none;
cursor:pointer;
background: ${(props) => (props.bgColor ? props.bgColor : "linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%)")};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border:1px solid ${(props) => (props.brColor ? props.brColor : "none")};
border-radius: 8px;
font-family: "P-SB";
padding: 10px 35px;
margin-right: 15px;
position: relative;
  display: inline-block;
  text-decoration: none;
  overflow: hidden;
  transition: 0.2s;
  /* span {
    position: absolute;
    display: block;
    &:nth-child(1) {
      top: 0;
      left: -100%;
      width: 100%;
      height: 2px;
      background: linear-gradient(90deg, transparent,  ${(props) => (props.LineColor ? props.LineColor : props.theme.textPrimary)});
    }
    &:nth-child(2) {
      top: -100%;
      right: 0;
      width: 2px;
      height: 100%;
      background: linear-gradient(180deg, transparent,  ${(props) => (props.LineColor ? props.LineColor : props.theme.textPrimary)});
    }
    &:nth-child(3) {
      bottom: 0;
      right: -100%;
      width: 100%;
      height: 2px;
      background: linear-gradient(270deg, transparent,  ${(props) => (props.LineColor ? props.LineColor : props.theme.textPrimary)});
    }
    &:nth-child(4) {
      bottom: -100%;
      left: 0;
      width: 2px;
      height: 100%;
      background: linear-gradient(360deg, transparent,  ${(props) => (props.LineColor ? props.LineColor : props.theme.textPrimary)});
    }
  }
  &:hover {
    color: ${(props) => (props.BgHoverTextColor ? props.BgHoverTextColor : props.theme.textSecondary)};
    background: ${(props) => (props.BgHoverColor ? props.BgHoverColor : props.theme.textPrimary)};
    box-shadow: 0 0 15px ${(props) => (props.BgHoverColor ? props.BgHoverColor : props.theme.textPrimary)}, 0 0 1px ${(props) => (props.BgHoverColor ? props.BgHoverColor : props.theme.textPrimary)}, 0 0 15px;
    transition-delay: 0.8s;
    span:nth-child(1) {
      left: 100%;
      transition: 0.6s;
    }
    span:nth-child(2) {
      top: 100%;
      transition: 1s;
      transition-delay: 0.1s;
    }
    span:nth-child(3) {
      right: 100%;
      transition: 1s;
      transition-delay: 0.3s;
    }
    span:nth-child(4) {
      bottom: 100%;
      transition: 1s;
      transition-delay: 0.5s;
    }
  } */
@media screen and (max-width:1199px){
  padding: 10px 20px;
  font-size: 13px;

}
@media screen and (max-width:499px){
  padding: 8px 20px;
  font-size: 13px;

}
`
const SectionHeading = styled.h3`
font-family: "P-B-I";
text-transform:uppercase;
  font-size: ${(props) => (props.fs ? props.fs : "150px")};
  color: ${(props) => props.theme.textPrimary};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  /* line-height: ${(props) => (props.lh ? props.lh : "50px")}; */
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "center")};
  @media screen and (max-width: 899px) {
    font-size: ${(props) => (props.fs899 ? props.fs899 : "120px")};
    padding: ${(props) => (props.p899 ? props.p899 : "0")};
  
  }
  @media (max-width: 699px) {
    font-size: ${(props) => (props.fs599 ? props.fs599 : "100px")};
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
  @media (max-width: 573px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "85px")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
  }
  @media (max-width: 483px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "50px")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
  }
`;
const SectionHeadingPer = styled.h3`
  font-family: "P-SB";
  position: absolute;
  top: 70px;
  left:0;
  z-index: 0;
  right: 0;
  font-size: ${(props) => (props.fs ? props.fs : "193px")};
  color: ${(props) => props.theme.bgSecondary};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  /* line-height: ${(props) => (props.lh ? props.lh : "50px")}; */
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "center")};
  @media screen and (max-width: 1199px) {
    font-size: 110px;
    top: 30px;
  }
  @media (max-width: 599px) {
    font-size: ${(props) => (props.fs599 ? props.fs599 : "80px")};
    padding: ${(props) => (props.p599 ? props.p599 : "")};
    /* top: 60px; */
  }
  @media (max-width: 399px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "70px")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
    top: 40px;
  }
`;
const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const MainWrapper = styled.div`
position: relative;
`
const CircleWrapper = styled.div`
  position: relative;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 1px solid black;
  /* margin: 0 auto; */
  background-color: #861CFF;
  animation: ${rotate360} 6s linear infinite;
`;

const TextInCircle = styled.img`
  position: absolute;
  top: 32%;
    bottom: 50%;
    left: 38%;
    right: 50%;
  z-index: 1;
  
`;

const DownloadLink = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: white;
  text-decoration: none;
  border-radius: 50%;
`;
const Div = styled.div`
display: flex; 
justify-content: end; 
padding: 10px 20px 0;  
@media screen and (max-width:599px){
  justify-content: center; 
  padding: 20px 20px 0;  

}
`

const PayDiv = styled.div`
display:flex;
align-items:center;
    justify-content: center;
@media screen and (max-width:899px){
  display:block;
}
@media screen and (max-width:599px){
gap:20px;
  display: inline-grid;
}
`
const Ca = styled.div`
  background-color: #fff;
  color: #000;
  padding: 10px 20px;
  border-radius:50px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 600px;
  font-family: "P-SB" !important;
@media screen and (max-width:899px){
    margin:20px 0;
  }
`
export { GridHEading, GridImage,JOiningLinks, BuyNow, SectionHeading, SectionHeadingPer, MainWrapper, CircleWrapper, TextInCircle, DownloadLink, Div, PayDiv, Ca };
